alertify.set({
  buttonReverse: true,
  labels : {
    ok : 'Да',
    cancel : 'Нет'
  }
});

function initCommonScripts() {
  'use strict';

  $(document.body)
    .on('overlayLoaderShow', function(e, $node) {
      $node.find('.autofocus-inp').focus();
    });
}

function parallaxes() {
  var commonController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onLeave',
        }
      }),
      staticSlidesController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onLeave',
        }
      });

  new ScrollMagic.Scene({
      triggerElement: '#rotator-slide',
      offset: $('.slide').height()
    })
    .setClassToggle('header', 'active')
    .addTo(commonController);

  new ScrollMagic.Scene({
      triggerElement: '.slides-container',
      offset: $('.slide').height()
    })
    .setClassToggle('.slides-nav', 'active')
    .addTo(commonController);

  new ScrollMagic.Scene({
      triggerElement: '#shop-slide',
      offset: $('.slide').height()
    })
    .setClassToggle('.slides-nav', 'hidden')
    .addTo(commonController);

  // commonController.scrollTo(function(target) {
  //   TweenMax.to(window, 0.5, {
  //     scrollTo: {
  //       y: target,
  //       autoKill: true
  //     },
  //     ease: Cubic.easeInOut
  //   });
  // });

  commonController.scrollTo(function(target) {
    var newScrollPos = target + $('.slide').height();
    $('html, body').scrollTop(newScrollPos);
  });

  $('.slides-nav a, .main-menu a, .hd-order-link, .js-skip-main-video, .go-down').click(function(e) {
    var self = $(this),
        target = self.attr('href');
    if ( $(target).length > 0 ) {
      e.preventDefault();
      if ( $(target).hasClass('static-slide') ) {
        staticSlidesController.scrollTo(target);
      } else {
        commonController.scrollTo(target);
      }
      self.closest('li').addClass('active').siblings().removeClass('active');
      if ( window.history && window.history.pushState ) {
        history.pushState('', document.title, target);
      }
    }
  });

  var slideFadeIn_1 = new TimelineMax()
        .fromTo('#rotator-slide', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#rotator-slide',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_1)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#rotator-slide',
      duration: $('.slide').height() + 600
    })
    .setPin('#rotator-slide')
    .addTo(commonController);

  var slideFadeIn_2 = new TimelineMax()
        .fromTo('#slide-1', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#slide-1',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_2)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-1',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-1')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-1',
      offset: $('.slide').height(),
      duration: $('.slide').height() + 600
    })
    .setClassToggle('#slide-1-anchor', 'active')
    .addTo(commonController);

  var slideFadeIn_3 = new TimelineMax()
        .fromTo('#slide-2', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#slide-2',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_3)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-2',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-2')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-2',
      offset: $('.slide').height(),
      duration: $('.slide').height() + 600
    })
    .setClassToggle('#slide-2-anchor', 'active')
    .addTo(commonController);

  var slideFadeIn_4 = new TimelineMax()
        .fromTo('#slide-3', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#slide-3',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_4)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-3',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-3')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-3',
      offset: $('.slide').height(),
      duration: $('.slide').height() + 1800
    })
    .setClassToggle('#slide-3-anchor', 'active')
    .addTo(commonController);

  var slidesFade = new TimelineMax()
        .fromTo('#slide-3', 1, {opacity: '1.0', zIndex: 96}, {opacity: '0.0', zIndex: 95, ease: Linear.easeNone})
        .fromTo('#slide-4', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#slide-3',
      offset: $('.slide').height() + 600,
      duration: 600
    })
    .setPin('#slide-3')
    .setTween(slidesFade)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-4',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-4')
    .addTo(commonController);

  var slideFadeIn_5 = new TimelineMax()
        .fromTo('#slide-5', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#slide-5',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_5)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-5',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-5')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-5',
      offset: $('.slide').height(),
      duration: $('.slide').height() + 600
    })
    .setClassToggle('#slide-4-anchor, #slide-5', 'active')
    .addTo(commonController);

  var slideFadeIn_6 = new TimelineMax()
        .fromTo('#slide-6', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#slide-6',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_6)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-6',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-6')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-6',
      offset: $('.slide').height(),
      duration: $('.slide').height() + 1800
    })
    .setClassToggle('#slide-5-anchor', 'active')
    .addTo(commonController);

  var slidesFade = new TimelineMax()
        .fromTo('#slide-6', 1, {opacity: '1.0', zIndex: 93}, {opacity: '0.0', zIndex: 92, ease: Linear.easeNone})
        .fromTo('#slide-7', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#slide-6',
      offset: $('.slide').height() + 600,
      duration: 600
    })
    .setPin('#slide-6')
    .setTween(slidesFade)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#slide-7',
      duration: $('.slide').height() + 600
    })
    .setPin('#slide-7')
    .addTo(commonController);

  var slideFadeIn_7 = new TimelineMax()
        .fromTo('#shop-slide', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#shop-slide',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_7)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#shop-slide',
      duration: $('.slide').height() + 600
    })
    .setPin('#shop-slide')
    .addTo(commonController);

  new ScrollMagic.Scene({
      triggerElement: '#register-slide',
    })
    .addTo(commonController);

  new ScrollMagic.Scene({
      triggerElement: '#register-slide',
      duration: 600
    })
    .setPin('#register-slide')
    .addTo(commonController);

  $('#company-slide-2').css('margin-top', -$(window).height() * 5 - 600 );
  var bgMove = new TweenMax.to('#company-slide-1 .wall-slider', 1, {top: '-300%', ease: Linear.easeNone});
  var slideFadeIn_8 = new TimelineMax()
        .fromTo('#company-slide-1', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  // new ScrollMagic.Scene({
  //     triggerElement: '#company-slide-1',
  //     duration: $('.slide').height()
  //   })
  //   .setTween(slideFadeIn_8)
  //   .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-1',
      duration: $('.slide').height() * 5 + 600 * 3
    })
    .setPin('#company-slide-1')
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-1',
      // offset: $('.slide').height(),
      duration: $('.slide').height() * 6
    })
    .setTween(bgMove)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-1',
      // offset: $('.slide').height(),
      duration: $('.slide').height() * 6 + 600
    })
    .setClassToggle('#company-slide-1', 'active')
    .addTo(commonController);

  var companySlidesFade_1 = new TimelineMax()
        .fromTo('#company-slide-1 .feature', 1, {left: '0px'}, {left: '-1000px', ease: Linear.easeNone})
        .fromTo('#company-slide-2', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-1',
      offset: $('.slide').height() + 600,
      duration: 600
    })
    .setTween(companySlidesFade_1)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-2',
      duration: $('.slide').height() + 600
    })
    .setPin('#company-slide-2')
    .addTo(commonController);

  var companySlidesFade_2 = new TimelineMax()
        .fromTo('#company-slide-2 .feature', 1, {left: '0px'}, {left: '-1000px', ease: Linear.easeNone})
        .fromTo('#company-slide-3', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-2',
      offset: 600,
      duration: 600
    })
    .setTween(companySlidesFade_2)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-3',
      duration: $('.slide').height() + 600
    })
    .setPin('#company-slide-3')
    .addTo(commonController);

  var companySlidesFade_3 = new TimelineMax()
        .fromTo('#company-slide-3 .feature', 1, {left: '0px'}, {left: '-1000px', ease: Linear.easeNone})
        .fromTo('#company-slide-4', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-3',
      offset: 600,
      duration: 600
    })
    .setTween(companySlidesFade_3)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-4',
      duration: 600
    })
    .setPin('#company-slide-4')
    .addTo(commonController);

  var companySlidesFade_4 = new TimelineMax()
        .fromTo('#company-slide-4 .feature', 1, {left: '0px'}, {left: '-1000px', ease: Linear.easeNone});
  new ScrollMagic.Scene({
      triggerElement: '#company-slide-4',
      offset: 200,
      duration: 600
    })
    .setTween(companySlidesFade_4)
    .addTo(commonController);

  var slideFadeIn_9 = new TimelineMax()
        .fromTo('#dinero-slide-1', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#dinero-slide-1',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_9)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#dinero-slide-1',
      duration: $('.slide').height() * 2
    })
    .setPin('#dinero-slide-1')
    .addTo(commonController);

  var slideFadeIn_10 = new TimelineMax()
        .fromTo('#dinero-slide-2', 1, {opacity: '0.0'}, {opacity: '1.0', ease: Cubic.easeInOut});
  new ScrollMagic.Scene({
      triggerElement: '#dinero-slide-2',
      duration: $('.slide').height()
    })
    .setTween(slideFadeIn_10)
    .addTo(commonController);
  new ScrollMagic.Scene({
      triggerElement: '#dinero-slide-2',
      duration: $('.slide').height() + 600
    })
    .setPin('#dinero-slide-2')
    .addTo(commonController);

}

$(function() {
  initCommonScripts();

  if ( isMobile ) {
    $('header').addClass('active');
  } else {
    parallaxes();
  }

  // OverlayLoader init
  $(document).on('click.overlay', '.js-overlay', function(e) {
    e.preventDefault();
    $.overlayLoader(true, $($(this).attr('href')));
  });

  $('.popup .close').click(function(e) {
    e.preventDefault();
    $.overlayLoader(false, $(this).closest('.popup'));
  });

  $('.fancybox').fancybox();

  $('input[type="tel"], .phone-input').each(function() {
    var $_this = $(this), val;
    $_this.mask('+7 (999) 999-99-99', {autoclear: false});
  });
});